import Radio from "backbone.radio";
import { sanitizeString, htmlEscape } from "../../../../utils";

import ChosenBehavior from "../../../../behaviors/chosen";
import ModalFormLayout from "../../../generic/form-layout";
import Body from "./form-body";
import Buttons from "../../../generic/button/collection";
import buttons from "./form-buttons";
import ProjectModel from "../../../../models/chart-reviews/project";

const NAME_REGEX = "[^A-Za-z0-9-_ &+]+";

const channel = Radio.channel("global");

class View extends ModalFormLayout {
  ui() {
    return {
      deleteBtn: "button.delete-project",
      closeBtn: "button.close-project",
    };
  }

  events() {
    return {
      submit: "_onSubmit",
      reset: "_onReset",
      "click @ui.closeBtn": "_onClose",
      "click @ui.deleteBtn": "_onDelete",
    };
  }

  behaviors() {
    return [{ behaviorClass: ChosenBehavior }];
  }

  childEvents() {
    return {
      attach: this._onChildAttach,
    };
  }

  _onChildAttach() {
    // notify behaviors of child content being attached
    this.triggerMethod("ContentRendered");
  }

  onBeforeShow() {
    this.body.show(
      new Body({
        model: this.model,
      })
    );

    this.buttons.show(
      new Buttons({
        buttons,
        meta: this.options,
      })
    );
  }

  _onReset() {
    // notify behaviors of form reset
    this.triggerMethod("Reset");
  }

  _onSubmit(e) {
    e.preventDefault();

    // extract submitted form data
    const formData = Backbone.Syphon.serialize(this);

    // trim name
    formData.name = sanitizeString(formData.name, NAME_REGEX);

    // cast managers to numbers
    formData.managers = formData.managers && formData.managers.map((id) => +id);

    // cast reviewers to number
    formData.reviewers =
      formData.reviewers && formData.reviewers.map((id) => +id);

    // encode notes
    formData.notes = htmlEscape(formData.notes);

    // create project model instance with form data
    const project = new ProjectModel(formData);

    // validate it
    if (project.isValid()) {
      // attempt to create project
      project.save(
        {},
        {
          success: this._onSync.bind(this),
          error: this._onSyncFailure.bind(this),
        }
      );
    } else {
      // show warning message
      channel.trigger("status:show", {
        type: "warning",
        message: project.validationError,
      });
    }
  }

  _onClose(e) {
    e.preventDefault();

    console.info("This will mark the project closed.");
  }

  _onDelete(e) {
    e.preventDefault();

    if (this.model.getDeletable()) {
      // destroy model
      this.model.destroy({
        success: this._onDestroyed.bind(this),
        error: this._onDestroyFailure.bind(this),
      });
    } else {
      // show error
      channel.trigger("status:show", {
        autoDismissTimeout: 6000,
        type: "warning",
        message:
          "Your project cannot be deleted. Please reassign its charts to another project, then try again.",
      });
    }
  }

  _onSync() {
    // show success message
    channel.trigger("status:show", {
      type: "success",
      message: "Your project details were updated successfully.",
    });

    // dismiss modal
    this.triggerMethod("dismiss:modal");
  }

  _onSyncFailure() {
    // show error
    channel.trigger("status:show", {
      autoDismiss: false,
      type: "danger",
      message: "Your project could not be updated.",
    });
  }

  _onDestroyed() {
    // show success message
    channel.trigger("status:show", {
      type: "success",
      message: "Your project was deleted successfully.",
    });

    // dismiss modal
    this.triggerMethod("dismiss:modal");
  }

  _onDestroyFailure() {
    // show error
    channel.trigger("status:show", {
      autoDismiss: false,
      type: "danger",
      message: "Your project could not be deleted.",
    });
  }
}

export { View as default };
